module.exports = __webpack_public_path__ + "img/aboutme.f240a572.png";